import { Tooltip } from "@material-ui/core";
import React from "react";
import './table.css'
class ChatBoxDataTable extends React.Component {
  constructor(props) {
    super(props);
    if(props.data.length > 0) {
      this.state = {
        data: props.data,
        fields: Object.keys(props.data[0]),
        old_last: "",
        old_first: "",
      };
    }
    else {
      this.state = {
        data: [],
        fields: [],
        old_last: "",
        old_first: "",
      };
    }
  }

  sortFunc(a,b) {
    const re = new RegExp("[0-9]+")
    if(re.test(a) && re.test(b)) {
      return parseFloat(a) < parseFloat(b)
    }
    return a < b
  }

  order(field_name) {
    if(this.state.data.length > 0) {
      // Check for Sort Order
      if(this.state.data[0][field_name] === this.state.old_first && this.state.data[this.state.data.length - 1][field_name] === this.state.old_last) {
        this.setState(e=>e.data.sort((a,b)=>(this.sortFunc(a[field_name],b[field_name])?1:-1)))
      }
      else {
        this.setState(e=>e.data.sort((a,b)=>(this.sortFunc(a[field_name],b[field_name])?-1:1)))
      }
      this.setState({
        old_first: this.state.data[0][field_name],
        old_last: this.state.data[this.state.data.length - 1][field_name]
      })
    }
  }

  copyToClipboard(text) {
    navigator.clipboard.writeText(text).then(() => {}).catch(err => {
      console.error('Failed to copy text: ', err);
    });
  }

  handleDownload() {
    // Customize your string here
    let customString = ""
    let row = ""
    for(let field of this.state.fields) {
      customString += `${field},`
    }
    customString = customString.slice(0, -1) + '\n'
    for(let item of this.state.data) {
      row  = ""
      for(let field of this.state.fields) {
        row += `${item[field]},`
      }
      customString += row.slice(0, -1) + '\n'
    }

    // Create a blob from the string
    const blob = new Blob([customString], { type: 'text/plain' });

    // Create a download link
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = 'data.csv';  // Set the file name

    // Programmatically click the link to trigger the download
    link.click();

    // Clean up by revoking the object URL
    window.URL.revokeObjectURL(link.href);
  }
  
  render() {
    return (
      <React.Fragment>
        <section style={{borderRadius:5}}>
          <Tooltip title="Download Data">
            <button className="download-button" onClick={()=>{this.handleDownload()}}>
              <img style={{maxHeight:30, maxWidth:30, borderRadius:10}} src={'/chat/download.svg'}/>
            </button>
          </Tooltip>
          <div class="tbl-header">
            <table cellPadding="0" cellSpacing="0" border="0">
              <thead>
                <tr>
                  {this.state.fields.map((obj,idx)=>{
                    return(
                      <th key={idx+obj.substring(0,3)} onClick={()=>{this.order(obj)}}>{obj}</th>
                    )
                  })}
                </tr>
              </thead>
            </table>
          </div>
          <div class="tbl-content">
            <table cellPadding="0" cellsPacing="0" border="0">
              <tbody>
                {this.state.data.map((obj,idx)=>{
                  return(
                    <tr key={idx}>
                      {this.state.fields.map((field, idx)=>{
                        return(
                          <td key={idx+field} onClick={()=>{this.copyToClipboard(obj[field])}}>{obj[field]}</td>
                        )
                      })}
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default ChatBoxDataTable;



// WEBPACK FOOTER //
// ./src/views/ChatPage/chatPageComponents/ChatBoxDataTable/ChatBoxDataTable.jsx